module.exports = __webpack_public_path__ + "static/media/waves.76eaf3c2.png";